import { CrudOp, partlistEntryAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { QualityMonitorIcon } from "@org-avp/avp-avengers-ui-shared-icons";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { QaMonitorView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { project }) => {
  const authHelper = authHelperCreator(partlistEntryAuthScope);
  return project != null && authHelper.evaluate(CrudOp.READ, project);
};

export const qaMonitorViewKey = "qa_modular_qaMonitor/:projectId/:subprojectId/:megTemplateId/:brand";
export const qaMonitorViewModule: ViewModule = {
  viewKey: qaMonitorViewKey,
  viewEl: <QaMonitorView/>,
  displayNameI18nKey: "qa:qaMonitor.viewName",
  menuIconEl: <QualityMonitorIcon/>,
  isAuthorized,
  translations,
};
